import StorageOrderIndexPage from "./StorageOrderIndexPage";
export default StorageOrderIndexPage;
